import { render } from "./Blog1View.vue?vue&type=template&id=113f6086"
import script from "./Blog1View.vue?vue&type=script&lang=js"
export * from "./Blog1View.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__